import { render } from "./InfoListPage.vue?vue&type=template&id=c51a823e"
import script from "./InfoListPage.vue?vue&type=script&lang=js"
export * from "./InfoListPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__